/* Somnaire theme scripts */
(function () {
  'use strict';
  const T = window.theme || { routes: {} };
  const R = T.routes;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    const num = (n, dec, th, ds) => {
      const parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    let v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = num(cents, 2, "'", '.'); break;
      default: v = num(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function toast(msg) {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(() => { t.hidden = true; }, 2400);
  }

  /* ---------- announcement ---------- */
  $$('[data-announce]').forEach((bar) => {
    const msgs = $$('[data-msg]', bar);
    if (msgs.length < 2) return;
    let i = 0;
    const speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
    setInterval(() => {
      msgs[i].hidden = true;
      i = (i + 1) % msgs.length;
      msgs[i].hidden = false;
    }, speed);
  });

  /* ---------- mobile menu ---------- */
  const burger = $('[data-burger]');
  if (burger) {
    burger.addEventListener('click', () => {
      const nav = $('#MobileNav');
      nav.hidden = !nav.hidden;
      burger.setAttribute('aria-expanded', String(!nav.hidden));
    });
  }

  /* ---------- search ---------- */
  const searchModal = $('#SearchModal');
  if (searchModal) {
    const input = $('#SearchInput');
    const results = $('#SearchResults');
    $$('[data-search-open]').forEach((el) => el.addEventListener('click', (e) => {
      e.preventDefault();
      searchModal.hidden = false;
      setTimeout(() => input.focus(), 30);
    }));
    searchModal.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-close]')) searchModal.hidden = true;
    });
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const url = `${R.root.replace(/\/$/, '')}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
          const data = await (await fetch(url)).json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          results.innerHTML = items.length
            ? items.map((p) => `<a href="${p.url}"><span class="th">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</span><span><b>${p.title}</b><br><span class="note">${p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : ''}</span></span></a>`).join('')
            : `<p class="muted">No results. Press Enter to search the whole store.</p>`;
        } catch (err) { results.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- cart drawer ---------- */
  const drawerWrap = $('#CartDrawer');
  const useDrawer = drawerWrap && T.cartType !== 'page';

  function setCount(n) {
    $$('[data-cart-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
  }
  function openCart() {
    if (!useDrawer) { window.location.href = R.cart; return; }
    drawerWrap.hidden = false;
    document.documentElement.classList.add('lock');
  }
  function closeCart() {
    if (!drawerWrap) return;
    drawerWrap.hidden = true;
    document.documentElement.classList.remove('lock');
  }
  async function refreshCart() {
    try {
      const [sec, cart] = await Promise.all([
        fetch(`${R.root.replace(/\/$/, '')}/?sections=cart-drawer`).then((r) => r.json()),
        fetch(`${R.cart}.js`).then((r) => r.json())
      ]);
      setCount(cart.item_count);
      if (drawerWrap && sec['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('.drawer');
        if (fresh) $('.drawer', drawerWrap).innerHTML = fresh.innerHTML;
      }
    } catch (err) { /* keep current state */ }
  }
  async function changeLine(line, quantity) {
    const d = $('.drawer', drawerWrap);
    d.classList.add('loading');
    await fetch(`${R.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
    });
    await refreshCart();
    d.classList.remove('loading');
  }
  async function addItems(body) {
    const res = await fetch(`${R.cartAdd}.js`, {
      method: 'POST',
      headers: body instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body instanceof FormData ? body : JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    return data;
  }

  if (useDrawer) {
    $$('[data-cart-open]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
    drawerWrap.addEventListener('click', async (e) => {
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      const q = e.target.closest('[data-line]');
      if (q) { changeLine(q.dataset.line, q.dataset.qty); return; }
      const up = e.target.closest('[data-upsell]');
      if (up) {
        up.disabled = true;
        try { await addItems({ items: [{ id: Number(up.dataset.upsell), quantity: 1 }] }); await refreshCart(); }
        catch (err) { toast(err.message); up.disabled = false; }
      }
    });
    drawerWrap.addEventListener('submit', (e) => {
      const f = e.target.closest('[data-discount-form]');
      if (!f) return;
      e.preventDefault();
      const code = f.discount.value.trim();
      if (!code) { toast('Enter a discount code first.'); return; }
      window.location.href = `${R.root.replace(/\/$/, '')}/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/checkout')}`;
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeCart();
    if (searchModal) searchModal.hidden = true;
    closeLightbox();
  });

  /* ---------- product page ---------- */
  $$('[data-product-section]').forEach((sec) => {
    const form = $('form[action*="/cart/add"]', sec);
    const varEl = $('[data-variants]', sec);
    if (!form || !varEl) return;
    const variants = JSON.parse(varEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const qtyInput = $('[data-qty-input]', form);
    const addBtn = $('[data-add]', form);
    const errEl = $('[data-form-error]', form);
    const priceEl = $('[data-price]', sec);
    const sticky = $('[data-sticky]', sec);
    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];

    const bundleDiscount = () => {
      const b = $('input[name="bundle"]:checked', form);
      return b ? Number(b.dataset.discount || 0) : 0;
    };

    function render() {
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      const d = bundleDiscount();
      const now = Math.round(current.price * qty * (1 - d / 100));
      const was = Math.max(current.compare_at_price || 0, current.price) * qty;
      priceEl.innerHTML = `<span class="now">${formatMoney(now)}</span>` +
        (was > now ? `<s>${formatMoney(was)}</s><span class="save">Save ${formatMoney(was - now)}</span>` : '');
      $$('[data-bundle-price]', form).forEach((el) => {
        const n = Number(el.dataset.bundlePrice);
        const inp = el.closest('.bundle').querySelector('input');
        const dd = Number(inp.dataset.discount || 0);
        el.textContent = formatMoney(Math.round(current.price * n * (1 - dd / 100)));
      });
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? 'Add to cart' : 'Sold out';
      if (sticky) {
        const sp = $('[data-sticky-price]', sticky);
        if (sp) sp.textContent = formatMoney(now);
      }
    }

    function selectedOptions() {
      const out = [];
      $$('input[data-option-index]:checked', form).forEach((i) => { out[Number(i.dataset.optionIndex)] = i.value; });
      return out;
    }

    form.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-option-index]')) {
        const opts = selectedOptions();
        const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
        if (match) {
          current = match;
          idInput.value = match.id;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
          if (match.featured_media && match.featured_media.preview_image) {
            showImage(match.featured_media.preview_image.src, match.featured_media.id);
          }
        } else {
          current = Object.assign({}, current, { available: false });
        }
      }
      if (t.name === 'bundle') qtyInput.value = t.value;
      render();
    });
    qtyInput.addEventListener('input', render);
    $$('[data-qty-step]', form).forEach((b) => b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qtyStep));
      render();
    }));

    function showImage(src, mediaId) {
      const main = $('[data-gallery-main]', sec);
      if (!main || !src) return;
      const sep = src.indexOf('?') > -1 ? '&' : '?';
      main.innerHTML = `<img src="${src}${src.indexOf('width=') > -1 ? '' : sep + 'width=1200'}" alt="">`;
      $$('.thumbs button', sec).forEach((b) => b.classList.toggle('on', String(b.dataset.mediaId) === String(mediaId)));
    }
    $$('.thumbs button', sec).forEach((b) => b.addEventListener('click', () => showImage(b.dataset.src, b.dataset.mediaId)));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errEl.hidden = true;
      const fd = new FormData(form);
      if (fd.get('selling_plan') === '') fd.delete('selling_plan');
      fd.delete('bundle');
      Array.from(fd.keys()).filter((k) => k.indexOf('option-') === 0).forEach((k) => fd.delete(k));
      addBtn.disabled = true;
      try {
        await addItems(fd);
        await refreshCart();
        if (useDrawer) openCart(); else window.location.href = R.cart;
      } catch (err) {
        errEl.textContent = err.message;
        errEl.hidden = false;
      }
      addBtn.disabled = !current.available;
    });

    if (sticky && 'IntersectionObserver' in window) {
      const sb = $('[data-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : addBtn.click());
      new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }).observe(addBtn);
    }
    render();
  });

  /* ---------- tabs (problem finder) ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    wrap.addEventListener('click', (e) => {
      const b = e.target.closest('[data-tab]');
      if (!b) return;
      $$('[data-tab]', wrap).forEach((x) => { const on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-selected', String(on)); });
      $$('[data-panel]', wrap).forEach((p) => { p.hidden = p.dataset.panel !== b.dataset.tab; });
    });
  });

  /* ---------- video slider + lightbox ---------- */
  const lightbox = $('#VideoLightbox');
  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    $('[data-lightbox-body]', lightbox).innerHTML = '';
    document.documentElement.classList.remove('lock');
  }
  if (lightbox) {
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) closeLightbox();
    });
  }
  $$('[data-videos]').forEach((wrap) => {
    const track = $('[data-vid-track]', wrap);
    $$('[data-vid-scroll]', wrap).forEach((b) => b.addEventListener('click', () => {
      track.scrollBy({ left: Number(b.dataset.vidScroll) * track.clientWidth * 0.8, behavior: 'smooth' });
    }));
    const vids = $$('video[data-autoplay]', wrap);
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { v.preload = 'auto'; v.play().catch(() => {}); } else { v.pause(); }
      }), { threshold: 0.4 });
      vids.forEach((v) => io.observe(v));
    }
    track.addEventListener('click', (e) => {
      const card = e.target.closest('[data-vid-src]');
      if (!card || !lightbox) return;
      const src = card.dataset.vidSrc;
      if (!src) return;
      const prod = $('[data-vid-product]', card);
      $('[data-lightbox-body]', lightbox).innerHTML =
        `<video src="${src}" controls autoplay playsinline loop></video>` +
        (prod ? `<a class="btn white" href="${prod.dataset.url}">Shop ${prod.dataset.title}</a>` : '');
      lightbox.hidden = false;
      document.documentElement.classList.add('lock');
    });
  });

  /* ---------- quiz ---------- */
  $$('[data-quiz]').forEach((quiz) => {
    const steps = $$('.q-step', quiz);
    const count = $('[data-quiz-count]', quiz);
    const bar = $('[data-quiz-bar]', quiz);
    const back = $('[data-quiz-back]', quiz);
    const box = $('.quiz', quiz);
    let step = 0;
    let result = null;
    const show = () => {
      steps.forEach((s, i) => { s.hidden = i !== step; });
      count.textContent = step + 1;
      bar.style.width = `${(step / steps.length) * 100}%`;
      back.hidden = step === 0;
    };
    quiz.addEventListener('click', (e) => {
      const a = e.target.closest('[data-answer]');
      if (a) {
        if (a.dataset.result) result = a.dataset.result;
        if (step < steps.length - 1) { step += 1; show(); return; }
        box.hidden = true;
        const panel = result ? $(`[data-result-panel="${result}"]`, quiz) : $('[data-result-panel]', quiz);
        if (panel) { panel.hidden = false; panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        return;
      }
      if (e.target.closest('[data-quiz-back]')) { step = Math.max(0, step - 1); show(); return; }
      if (e.target.closest('[data-quiz-restart]')) {
        $$('[data-result-panel]', quiz).forEach((p) => { p.hidden = true; });
        box.hidden = false; step = 0; result = null; show();
      }
    });
    show();
  });

  /* ---------- track order ---------- */
  $$('[data-track-form]').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault();
    const num = f.tracking.value.trim();
    if (!num) return;
    const prefix = f.dataset.prefix;
    if (prefix) window.open(prefix + encodeURIComponent(num), '_blank', 'noopener');
    else window.location.href = R.account;
  }));

  /* ---------- recommendations ---------- */
  $$('[data-recs]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* no recommendations */ }
  });

  /* ---------- collection sort + autosubmit selects ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));
  $$('[data-autosubmit]').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* ---------- password recover toggle ---------- */
  $$('[data-toggle-recover]').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault();
    const box = $('#recover');
    if (box) box.scrollIntoView({ behavior: 'smooth' });
  }));
})();
